var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.89 103.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ed1c24;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#fff;}.cls-3{fill:#5fa2d0;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.46,
    y: 4.5,
    width: 98.43,
    height: 98.43,
    rx: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 98.43,
    height: 98.43,
    rx: 9.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.74,64.18A13.4,13.4,0,0,1,24.3,54.9,13.19,13.19,0,0,0,30,54.73a1.43,1.43,0,0,0,.19-.09,13.34,13.34,0,0,1-8.68-6.14,12.94,12.94,0,0,1-2-7.11,13,13,0,0,0,6,1.62A13.46,13.46,0,0,1,20,34.9a13.25,13.25,0,0,1,1.44-9.69A38.27,38.27,0,0,0,49,39.19c-.08-.53-.16-1-.21-1.46a13,13,0,0,1,2-8.75,12.84,12.84,0,0,1,9.07-6,13,13,0,0,1,11.71,3.72.66.66,0,0,0,.71.22,27.15,27.15,0,0,0,7.78-3l.18-.1h.09a13.69,13.69,0,0,1-5.73,7.27,25.7,25.7,0,0,0,7.45-2l0,.06c-.51.67-1,1.35-1.54,2a26,26,0,0,1-4.86,4.62.46.46,0,0,0-.22.42,35.8,35.8,0,0,1-.25,5.94A39.28,39.28,0,0,1,71.78,54a38.76,38.76,0,0,1-7.23,10.54A35.8,35.8,0,0,1,46.17,74.8a40.53,40.53,0,0,1-7.45.88,37.75,37.75,0,0,1-21.4-5.74L17,69.73a26.94,26.94,0,0,0,13.38-1.84A26.5,26.5,0,0,0,36.74,64.18Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.03443120abf5e87e263903cd0f902302.svg";
export { ForwardRef as ReactComponent };